export default __webpack_public_path__ + "9d49e8583524005fb075468315762a7f.svg";